<div class="color-options">
  <div
    *ngFor="let color of colors"
    [class.selected]="formControl.value === color"
    [style.background-color]="color"
    (click)="selectColor(color)"
    class="color-option"
    title="'Select color' | translate"
  ></div>
</div>
